module.exports = __webpack_public_path__ + "img/RomanCapTechFortification_Default.c5709cf7.webp";